<script>
  export let text
  export let ref
  import {
    createEventDispatcher
  } from 'svelte';

  const dispatch = createEventDispatcher();
</script>

<button on:click="{() => dispatch('pressed', {ref})}" type="button">{text}</button>

<style>
  button {
    position: relative;
    top: 0;
    left: 0;
    padding: 16px 20px;
    background: #FDFFFC;
    border: 2px solid #202020;
    box-shadow: 4px 4px 0px #FF9F1C;
    border-radius: 28px;
    transition: 0.1s;
    outline: none;
  }

  button:hover,
  button:focus {
    top: 2px;
    left: 2px;
    box-shadow: 2px 2px 0px #FF9F1C;
  }

  button:active {
    top: 4px;
    left: 4px;
    box-shadow: 0px 0px 0px;
  }
</style>
